import * as types from '../constants/ActionTypes';

const initialState = {
  display: false,
  decided: false,
  authorized: false,
  isSending: false,
  error: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.INIT_AUTH_CALL:
      return Object.assign({}, state, { decided: false, display: action.payload, error: false });
    case types.CONFIRM_AUTH_CALL:
      return Object.assign({}, state, { decided: true, authorized: true, error: false, isSending: false });
    case types.REJECT_AUTH_CALL:
      return Object.assign({}, state, { decided: true, authorized: false, error: false, isSending: false });
    case types.SENDING_CONFIRM:
      return Object.assign({}, state, { decided: true, error: false, isSending: true });
    case types.AUTH_FAILED:
      return Object.assign({}, state, { decided: true, error: true, isSending: false });
    case types.CLOSE_AUTH_CALL:
      return initialState;
    default:
      return state;
  }
}
